
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Redirect } from "@/types/redirectTypes";
import RedirectForm from "./RedirectForm";

interface RedirectDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  redirect: Redirect | null;
  onSuccess: (redirect: Redirect) => void;
}

const RedirectDialog: React.FC<RedirectDialogProps> = ({
  open,
  onOpenChange,
  redirect,
  onSuccess,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>
            {redirect ? "Edit Redirect" : "Create New Redirect"}
          </DialogTitle>
        </DialogHeader>
        
        <RedirectForm
          redirect={redirect || undefined}
          onSuccess={onSuccess}
          onCancel={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
};

export default RedirectDialog;
